<template>
  <!-- eslint-disable max-len -->
  <div class="Table">
    <div class="row">
      <div class="col category">
        <span
          class="bold"
        >¿Qué tipo de información personal recopilamos sobre usted?</span>
        <img
          alt="Document icon"
          src="../assets/document.png"
        >
      </div>
      <div class="col information">
        <ul>
          <li>
            <span class="bold">Información de contacto</span>
            (p. ej., nombre, número de teléfono, domicilio postal y dirección de correo electrónico).
          </li>
          <li>
            <span class="bold">Información de la cuenta del programa de fidelidad </span>
            (p. ej., nombre de la cuenta, número o contraseña, puntos y selección de recompensas).
          </li>
           <li>
            <span class="bold">Información demográfica </span>
            (p. ej., edad, género, raza, ingresos, ocupación, estado civil e información sobre su situación de familia/hogar, incluido el tamaño de su hogar y el tiempo que lleva viviendo en su residencia).
          </li>
          <li>
            <span class="bold">Información de pago </span>
            (p. ej., nombre, domicilio de facturación e información de la tarjeta de crédito o débito).
          </li>
          <li>
            <span class="bold">Información de voz y audio</span>
            (podemos grabar las llamadas telefónicas entre usted y Synapse).
          </li>
          <li>
            <span class="bold">Otra información que eligiese proporcionar de manera voluntaria</span>
            (p. ej., fotos, comentarios o información sobre otras personas que publica o nos envía).
          </li>
          <li>
            <span class="bold">Identificadores en línea  </span>
            (p. ej., dirección IP, identificadores internos y de terceros, identificadores de publicidad e información del dispositivo, como su id. de dispositivo único).
          </li>
          <li>
            <span class="bold">Información de la ubicación </span>
            (información sobre su ubicación general obtenida a partir de una dirección IP).
          </li>
          <li>
            <span
              class="bold"
            >Información de actividades en Internet</span>
            (p. ej., historial de navegación, información sobre cómo interactúa con nuestros Sitios, p. ej., sobre qué artículos o anuncios hace clic, si hace clic en los enlaces de nuestros correos electrónicos y sus interacciones con funciones de plataformas de redes sociales).
          </li>
          <li>
            <span class="bold">Conclusiones sobre sus intereses, preferencias y otros datos conductuales </span>
            (en función del uso que usted hace o sus opiniones sobre diversos productos, programas y servicios).
          </li>
        </ul>
        <a
          class="more"
          href="#personal"
        >MÁS</a>
      </div>
    </div>

    <div class="row">
      <div class="col category">
        <span
          class="bold"
        >¿Cómo recopilamos la información personal?</span>
        <img
          alt="Devices icon"
          src="../assets/devices.png"
        >
      </div>
      <div class="col information">
        <ul>
          <li>
            <span class="bold">Proveniente de usted</span>
            <ul>
              <li>Cuando nos proporcionase información a través de los Sitios.</li>
            </ul>
          </li>
          <li>
            <span class="bold">Proveniente de su dispositivo</span>
            <ul>
              <li>
                A partir de las cookies y tecnologías similares (p. ej., información personal almacenada en su navegador, que nos indica su navegador, información del dispositivo, dirección IP y cómo interactúa con los Sitios).
              </li>
            </ul>
          </li>
          <li>
            <span class="bold">Proveniente de otras fuentes</span>
            <ul>
              <li>Marcas asociadas</li>
              <li>Socios de datos</li>
            </ul>
          </li>
        </ul>
        <a
          class="more"
          href="http://privacy.synapsegroupinc.com/?id=SG#collect"
        >MÁS</a>
      </div>
    </div>

    <div class="row">
      <div class="col category">
        <span class="bold">¿Cómo utilizamos la información personal?</span>
        <img
          alt="Gear icon"
          src="../assets/gear.png"
        >
      </div>
      <div class="col information">
        <ul>
          <li>
            Para
            <span
              class="bold"
            > ofrecer los Sitios </span> <span> y</span> <span class="bold">cumplir con sus solicitudes</span>
            relativas a nuestras publicaciones, productos o servicios.
          </li>
          <li>
            Para
            <span class="bold"> mejorara los Sitios </span> <span>y</span> <span class="bold">prestar servicios personalizados.</span>
          </li>
          <li>
            Para proporcionar 
            <span class="bold"> nuestro boletín informativo</span>
            y para otros fines de marketing.
          </li>
          <li>
            Para
            <span
              class="bold"
            > otros fines comerciales</span>
            descritos más detenidamente a continuación.
          </li>
        </ul>
        <a
          class="more"
          href="#use"
        >MÁS</a>
      </div>
    </div>

    <div class="row">
      <div class="col category">
        <span
          class="bold"
        >¿Con quién compartimos la información personal?</span>
        <img
          alt="Person Icon"
          src="../assets/person.png"
        >
      </div>
      <div class="col information">
        <ul>
          <li>
            Entre las <span class="bold">marcas de Synapse</span>
          </li>
          <li>
            Con <span class="bold">editores</span> que se han asociado con nosotros (con su consentimiento)
          </li>
          <li>
            Con nuestros <span class="bold">proveedores de servicios</span><span> y</span> <span class="bold"> procesadores de pagos</span>
            que nos ayudan a operar nuestros Sitios y a brindarle nuestros servicios
          </li>
          <li>
            Con un <span class="bold">comprador de la totalidad o de una parte de nuestra empresa</span>
          </li>
          <li>
          Con otros terceros
          <span class="bold">si contamos con su consentimiento
          </span>
          </li>
          <li>
          Cuando 
          <span class="bold">lo requiriesen las leyes
          </span>
          </li>
        </ul>
        <a
          class="more"
          href="#social"
        >MÁS</a>
      </div>
    </div>

    <div class="row">
      <div class="col category">
        <span
          class="bold"
        >¿Cómo puede controlar el uso que hacemos de la información personal?</span>
        <img
          alt="Lock icon"
          src="../assets/lock.png"
        >
      </div>
      <div class="col information">
        <ul>
          <li>
          Para solicitar la eliminación de su información personal o el acceso a esta,<a href="http://privacy.synapsegroupinc.com/optout.html?id=SG" target="_blank" rel="noreferrer noopener" class="bold"> haga clic aquí.</a>
          </li>
          <li>
          Si prefiriese no recibir promociones de Synapse,<a href="http://privacy.synapsegroupinc.com/optout.html?id=SG"
              target="_blank"
              rel="noopener noreferrer"
              class="bold"
            >haga clic aquí.</a>.
          </li>
         </ul>
        <a
          class="more"
          href="#control"
        >MÁS</a>
      </div>
    </div>

    <div class="row">
      <div class="col category">
        <span class="bold">Privacidad de los niños</span>
        <img
          alt="Child icon"
          src="../assets/child.png"
        >
      </div>
      <div class="col information">
        No recopilamos deliberadamente Información Personal de personas menores de 16
        años.
        <a
          class="more"
          href="#children"
        >MÁS</a>
      </div>
    </div>

    <div class="row">
      <div class="col category">
        <span
          class="bold"
        >Derechos para nuestros residentes de California</span>
        <img
          alt="California icon"
          src="../assets/california.png"
        >
      </div>
      <div class="col information">
       Si fuese residente de California, tiene derecho a acceder y solicitar la eliminación de su información personal. No lo discriminaremos por ejercer estos derechos. 
            <br/>
            <br/>
            <ul>
            <span
              class="bold"
             >No vendemos su información personal.</span>
             <br/><br/>
             </ul>
            <span
              class="bold"
            > Tampoco compartimos su información personal con terceros para fines de marketing directo de estos sin que prestase consentimiento.</span>
        <a
          class="more"
          href="#section4"
        >MÁS</a>
      </div>
    </div>

    <div class="row">
      <div class="col category">
        <span class="bold">Derechos para nuestros residentes de Nevada</span>
        <img
          alt="Nevada Iscon"
          src="../assets/nevada.png"
        >
      </div>
      <div class="col information">
     <span class="bold">No vendemos su información personal.</span>
         <a href="#learn" class="more"
        >MÁS</a>
      </div>
    </div>
    <div class="row">
      <div class="col category">
        <span class="bold">Cómo puede obtener más información</span>
        <img
          alt="Lightbulb icon"
          src="../assets/lightbulb.png"
        >
      </div>
      <div class="col information">
       Haga clic aquí para leer nuestra <a href="#personal" class="underlineonly">Declaración de privacidad completa.</a> 
        <br>
        <br>¿Aún no puede encontrar lo que busca acerca de nuestras prácticas sobre privacidad de datos?  No se preocupe, <a
                  href="mailto:privacysupport@synapsemail.com" class="bold"
             >haqa clic aquí</a> para comunicarse con nosotros por correo electrónico ¡y nos comunicaremos con usted!
        <a
          class="more"
          href="#learn"
        >MÁS</a>
      </div>
  </div>
  </div>
</template>

<script>
export default {
	name: 'Table',
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped lang="scss">
.Table {
  border: 1px solid darkgray;
}

.row {
  display: flex;
  flex-direction: column;

  @media (min-width: 576px) {
    flex-direction: row;
  }
}

.col.category {
  padding: 1em 0.5em;
  border-bottom: 1px dashed darkgray;

  img {
    display: block;
    margin: auto;
    width: 100px;
    height: auto;
  }

  @media (min-width: 576px) {
    width: 400px;
    border-bottom: 1px solid darkgray;
    border-right: 1px dashed darkgray;
  }
}

.col.information {
  padding: 1em 0.5em;
  border-bottom: 1px solid darkgray;

  ul {
    margin: 0;
  }

  a.more {
    width: 100%;
    display: block;
    text-align: right;
  }
.underlineonly{
   text-decoration: underline;
}
  @media (min-width: 576px) {
    width: 400px;
    flex-grow: 1;
  }
}
</style>
